import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Modal from "react-modal";
import { selectToken } from "../auth/auth.selector";
import { trainerOccupency, trainerShift } from "../../data/ApiEndpoints";
import { BASE_URL } from "../../data/BaseUrl";
import Loader from "../../components/ui/Loader";
import { startOfMonth, endOfMonth, format, addDays } from "date-fns";
import moment from "moment";
import { Button } from "react-bootstrap";
import DateRanger from "./DateRanger";
import ReactSelect from "react-select";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import { convertTime } from "../common-data/Converts";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import { CheckCircleIcon, CrossCircleIcon } from "../../images/icons/icons";

const OccupencyDetails = ({ queryParametersForAll }) => {
  const token = useSelector(selectToken);
  const [shiftData, setShiftData] = useState();
  const [selectedWeek, setSelectedWeek] = useState(null);
  const [weekData, setWeekData] = useState(null);
  const [dateRangerOpen, setDateRangerOpen] = useState(false);
  const initialRangeState = [
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ];
  const [rangeState, setRangeState] = useState(initialRangeState);
  const [startAndEndDate, setStartAndEndDate] = useState(
    getCurrentMonthRange()
  );
  const [occupencyData, setOccupencyData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingOc, setIsLoadingOc] = useState(false);
  const iniModalValues = {
    memDetailModal: false,
    memDetail: [],
    currentDate: "",
  };
  const [memDetails, setMemDetails] = useState(iniModalValues);
  const iniBookingValues = {
    bookingDetailModal: false,
    bookingDetail: [],
  };
  const [bookingDetails, setBookingDetails] = useState(iniBookingValues);

  const urlSearchParams = new URLSearchParams(queryParametersForAll);
  const trainerIdQueryParam = urlSearchParams.get("trainer_id");

  const onCloseModal = (e, name) => {
    e.preventDefault();

    if (name === "booking") {
      setBookingDetails(iniBookingValues);
    } else {
      setMemDetails(iniModalValues);
    }
  };

  async function getShiftData() {
    try {
      setIsLoading(true);
      const res = await fetch(
        `${BASE_URL}${trainerShift}?trainer_id=${trainerIdQueryParam}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const { data } = await res.json();
      if (data?.slot_details) {
        setShiftData([...data?.slot_details]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }

  async function getOccupencyData() {
    try {
      setIsLoadingOc(true);
      const id = trainerIdQueryParam;
      const date_to = selectedWeek?.value[selectedWeek?.value?.length - 1];
      const res = await fetch(
        `${BASE_URL}${trainerOccupency}?trainer_id=${id}&date_from=${selectedWeek?.value[0]}&date_to=${date_to}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const { data, status } = await res.json();
      setOccupencyData(null);

      if (data) {
        let allData = {};
        Object.entries(data).forEach(([key, value]) => {
          const firstObj = value[0];
          // const dates = firstObj?.booked_dates;
          const dates = firstObj?.booked_dates_v2;
          const newSlotData = dates.map((date) => {
            return {
              ...firstObj,
              date: date?.date,
              consumed_status: date?.consumed_status,
              members: value,
            };
          });
          allData[key] = newSlotData;
        });
        setOccupencyData(formatOccupencyData(allData));
      } else {
        setOccupencyData(formatOccupencyData({}));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingOc(false);
    }
  }

  function loader() {
    try {
      if (isLoading) {
        return true;
      }
      if (isLoadingOc) {
        return true;
      }
      return false;
    } catch (error) {
      console.log(error);
    }
  }

  const handleDateRangeChange = (item) => {
    try {
      setRangeState([item?.selection]);
      const formattedStartDate = format(
        item?.selection?.startDate,
        "yyyy-MM-dd"
      );
      const formattedEndDate = format(item?.selection?.endDate, "yyyy-MM-dd");
      const formattedStart = moment(formattedStartDate)
        .tz("Asia/Kolkata")
        .format("DD-MM-YYYY");
      const formattedEnd = moment(formattedEndDate)
        .tz("Asia/Kolkata")
        .format("DD-MM-YYYY");

      const dateRangeArray = [];
      const currentDate = moment(formattedStartDate).tz("Asia/Kolkata");
      const endDate = moment(formattedEndDate).tz("Asia/Kolkata");
      while (currentDate <= endDate) {
        dateRangeArray.push(currentDate.format("DD-MM-YYYY"));
        currentDate.add(1, "days");
      }
      setStartAndEndDate({
        ...startAndEndDate,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        selectedDates: `${formattedStart} to ${formattedEnd}`,
        dates: dateRangeArray,
      });
    } catch (error) {
      console.log(error);
    }
  };

  function formatOccupencyData1(data) {
    try {
      const res = [];
      const weekData = selectedWeek?.value;

      for (let i = 0; i < shiftData?.length; i++) {
        const currentShiftTime = shiftData[i]?.start_time
          ? `${shiftData[i]?.start_time}-${shiftData[i]?.end_time}`
          : null;

        for (let j = 0; j < weekData.length; j++) {
          const currentDate = weekData[j];

          const currentSlotData = currentShiftTime
            ? data && data[currentShiftTime]
            : null;

          const foundItem =
            currentSlotData &&
            currentSlotData.find((item) => {
              return item.date === currentDate;
            });

          if (foundItem) {
            if (
              moment(currentDate, "DD-MM-YYYY")
                .tz("Asia/Kolkata")
                .isBefore(moment().tz("Asia/Kolkata"), "day")
            ) {
              res.push({
                name: `PT Session(${foundItem?.members?.length || 0}/Expired)`,
                members: foundItem?.members,
                current_date: currentDate,
              });
            } else {
              res.push({
                name: `PT Session(${foundItem?.members?.length || 0})`,
                members: foundItem?.members,
                current_date: currentDate,
              });
            }
          } else if (currentDate === weekData[j - 1]) {
            res.push({ name: "-" });
          } else {
            if (
              moment(currentDate, "DD-MM-YYYY")
                .tz("Asia/Kolkata")
                .isBefore(moment().tz("Asia/Kolkata"), "day")
            ) {
              res.push({ name: "Expired" });
            } else {
              res.push({ name: "Available" });
            }
          }
        }

        //   if (foundItem) {
        //     res.push({
        //       name: `PT Session(${foundItem?.members?.length || 0})`,
        //       members: foundItem?.members,
        //       current_date: currentDate,
        //     });
        //   } else if (currentDate === weekData[j - 1]) {
        //     res.push({});
        //   } else {
        //     res.push({ name: "Available" });
        //   }
        // }
      }
      return res;
    } catch (error) {
      console.log(error);
    }
  }

  function formatOccupencyData(bookedData) {
    try {
      const res = [];
      const weekData = selectedWeek?.value;
      const currentMonthLastDate = moment()
        .tz("Asia/Kolkata")
        .endOf("month")
        .format("DD-MM-YYYY");

      for (let i = 0; i < shiftData?.length; i++) {
        const currentShiftTime = shiftData[i]?.start_time
          ? `${shiftData[i]?.start_time}-${shiftData[i]?.end_time}`
          : null;

        for (let j = 0; j < weekData.length; j++) {
          const currentDate = weekData[j];

          if (currentDate <= currentMonthLastDate) {
            const currentSlotData = currentShiftTime
              ? bookedData && bookedData[currentShiftTime]
              : "Avalable";

            const foundItem =
              currentSlotData &&
              currentSlotData.find((item) => {
                return item.date === currentDate;
              });

            if (currentDate === weekData[j - 1]) {
              res.push({ name: "-" });
            } else if (foundItem) {
              if (
                moment(currentDate, "DD-MM-YYYY")
                  .tz("Asia/Kolkata")
                  .isBefore(moment().tz("Asia/Kolkata"), "day")
              ) {
                res.push({
                  name: `PT Session(${
                    foundItem?.members?.length || 0
                  }/Expired)`,
                  members: foundItem?.members,
                  current_date: currentDate,
                });
              } else {
                res.push({
                  name: `PT Session(${foundItem?.members?.length || 0})`,
                  members: foundItem?.members,
                  current_date: currentDate,
                });
              }
            }
            // else if (currentDate === weekData[j - 1]) {
            //   res.push({ name: "-" });
            // }
            else {
              if (
                moment(currentDate, "DD-MM-YYYY")
                  .tz("Asia/Kolkata")
                  .isBefore(moment().tz("Asia/Kolkata"), "day")
              ) {
                res.push({ name: "Expired" });
              } else {
                res.push({ name: "Available" });
              }
            }
          }
        }
      }
      return res;
    } catch (error) {
      console.log(error);
    }
  }

  const splitDatesIntoWeeks = (datesArray) => {
    const dates = [...datesArray];
    const datesLength = dates.length;
    const weekLength = Math.ceil(datesLength / 7);
    const weeks = [];

    for (let i = 0; i < weekLength; i++) {
      const startIdx = i * 7;
      const endIdx = startIdx + 7;
      const currentWeek = dates.slice(startIdx, endIdx);

      while (currentWeek.length < 7) {
        const lastDate = currentWeek[currentWeek.length - 1];
        const nextDay = moment(lastDate, "DD-MM-YYYY")
          .tz("Asia/Kolkata")
          .add(1, "day");

        if (
          nextDay.month() ===
          moment(lastDate, "DD-MM-YYYY").tz("Asia/Kolkata").month()
        ) {
          currentWeek.push(nextDay.format("DD-MM-YYYY"));
        } else {
          const lastDayOfMonth = moment(lastDate, "DD-MM-YYYY")
            .tz("Asia/Kolkata")
            .endOf("month");
          currentWeek.push(lastDayOfMonth.format("DD-MM-YYYY"));
        }
      }
      const start = `${currentWeek[0].split("-")[0]}/${
        currentWeek[0].split("-")[1]
      }`;

      const newStart = moment(start, "DD/MM")
        .tz("Asia/Kolkata")
        .format("DD MMM");

      const end = `To ${currentWeek[currentWeek?.length - 1].split("-")[0]}/${
        currentWeek[currentWeek?.length - 1].split("-")[1]
      }`;
      const newEnd = moment(end, "DD/MM").tz("Asia/Kolkata").format("- DD MMM");

      const res = {
        label: `${newStart} ${newEnd}`,
        value: currentWeek,
      };
      weeks.push(res);
    }

    return weeks;
  };

  const splitDatesIntoWeeks1 = (datesArray) => {
    const dates = [...datesArray];
    const weeks = [];

    const sortedDates = dates.sort(
      (a, b) =>
        moment(a, "DD-MM-YYYY").tz("Asia/Kolkata").valueOf() -
        moment(b, "DD-MM-YYYY").tz("Asia/Kolkata").valueOf()
    );

    let currentWeek = [];
    let currentDate = moment(sortedDates[0], "DD-MM-YYYY")
      .tz("Asia/Kolkata")
      .startOf("week");

    sortedDates.forEach((date) => {
      const momentDate = moment(date, "DD-MM-YYYY").tz("Asia/Kolkata");

      if (momentDate.isSame(currentDate, "week")) {
        currentWeek.push(date);
      } else {
        weeks.push({
          label: `${currentDate.format("DD MMM")} to ${moment(
            currentWeek[currentWeek.length - 1],
            "DD-MM-YYYY"
          )
            .tz("Asia/Kolkata")
            .format("DD MMM")}`,
          value: currentWeek,
        });

        // Start a new week
        currentWeek = [date];
        currentDate = momentDate.startOf("week");
      }
    });

    // Add the last week
    if (currentWeek.length > 0) {
      weeks.push({
        label: `${currentDate.format("DD MMM")} to ${moment(
          currentWeek[currentWeek.length - 1],
          "DD-MM-YYYY"
        )
          .tz("Asia/Kolkata")
          .format("DD MMM")}`,
        value: currentWeek,
      });
    }

    return weeks;
  };

  function getCurrentMonthRange() {
    try {
      const startDate = startOfMonth(new Date());
      const endDate = endOfMonth(new Date());
      const formattedStartDate = format(startDate, "yyyy-MM-dd");
      const formattedEndDate = format(endDate, "yyyy-MM-dd");
      const formattedStart = moment(formattedStartDate)
        .tz("Asia/Kolkata")
        .format("DD-MM-YYYY");
      const formattedEnd = moment(formattedEndDate)
        .tz("Asia/Kolkata")
        .format("DD-MM-YYYY");

      const dateRangeArray = [];
      const currentDate = moment(formattedStartDate).tz("Asia/Kolkata");
      const endMomentDate = moment(formattedEndDate).tz("Asia/Kolkata");
      while (currentDate <= endMomentDate) {
        dateRangeArray.push(currentDate.format("DD-MM-YYYY"));
        currentDate.add(1, "days");
      }

      return {
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        selectedDates: `${formattedStart} to ${formattedEnd}`,
        dates: dateRangeArray,
      };
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    // try {
    //   const weekOptions = splitDatesIntoWeeks(startAndEndDate.dates);
    //   setWeekData(weekOptions);

    //   const currentDate = moment();
    //   const currentWeekIndex = weekOptions.findIndex((week) =>
    //     week.value.find((date) =>
    //       moment(date, "DD-MM-YYYY").isSame(currentDate, "week")
    //     )
    //   );

    //   setSelectedWeek(
    //     currentWeekIndex !== -1 ? weekOptions[currentWeekIndex] : weekOptions[0]
    //   );
    // } catch (error) {
    //   console.log(error);
    // }

    try {
      const weekOptions = splitDatesIntoWeeks(startAndEndDate.dates);
      setWeekData(weekOptions);

      const currentDate = moment().tz("Asia/Kolkata");
      const currentWeekIndex = weekOptions.findIndex((week) =>
        week.value.find((date) =>
          moment(date, "DD-MM-YYYY")
            .tz("Asia/Kolkata")
            .isSame(currentDate, "week")
        )
      );
      // const currentWeekIndex = weekOptions.findIndex((week) =>
      //   week.value.find((date) =>
      //     moment(date, "DD-MM-YYYY").isAfter(currentDate, "week")
      //   )
      // );

      setSelectedWeek(weekOptions[currentWeekIndex] || weekOptions[0]);
    } catch (error) {
      console.log(error);
    }
  }, [startAndEndDate]);

  useEffect(() => {
    if (trainerIdQueryParam) {
      try {
        getShiftData();
      } catch (error) {
        console.log(error);
      }
    }
  }, [trainerIdQueryParam]);

  useEffect(() => {
    if (shiftData && selectedWeek) {
      getOccupencyData();
    }
  }, [shiftData, startAndEndDate, selectedWeek]);

  const tbColumns = [
    {
      dataField: "member_name",
      text: "Member Name",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.member_name || "NA"}</span>;
      },
    },
    {
      dataField: "date",
      text: "PT Date Added",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {memDetails.currentDate || "-"}
          </span>
        );
      },
    },
    {
      dataField: "date",
      text: "PT Plan Duration",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100 underline lineHeight22px">
            {row?.date || "-"} <br /> {row?.expire_date || "-"}
          </span>
        );
      },
    },
    {
      dataField: "start_time",
      text: "Slot Time",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100 underline lineHeight22px">
            {row?.start_time ? convertTime(row.start_time) : "-"} <br />
            {row?.end_time ? convertTime(row.end_time) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "consumed_status",
      text: "Sessions Status",
      formatter: (cell, row) => {
        const isConsume = row?.booked_dates_v2?.filter(
          (da) => memDetails.currentDate === da?.date
        )?.[0]?.consumed_status;

        return (
          <span
            className="tb-data minWidth150"
            style={{
              color: isConsume ? "#379C00" : "#D90000",
            }}
          >
            {isConsume ? "Consumed" : "Not Consumed"}
            {isConsume ? <CheckCircleIcon /> : <CrossCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "n_session",
      text: "Sessions",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.n_session || "0"}</span>;
      },
    },
    {
      dataField: "consumed_session",
      text: "Total Sessions Consumed",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data hoverBlue link"
            style={{
              textDecoration: "underline",
            }}
            onClick={(e) =>
              setBookingDetails((prevs) => ({
                ...prevs,
                bookingDetailModal: true,
                bookingDetail: row?.booked_dates_v2,
              }))
            }
          >
            {row?.consumed_session || "0"}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius27"
            style={{
              background: row?.status === "active" ? "#E2EFD5" : "#F3DADA",
              color: row?.status === "active" ? "#379C00" : "#D90000",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
    // {
    //   dataField: "action",
    //   text: "Action",
    //   formatter: (cell, row) => (
    //     <div className="actionButtonContainer">
    //       <button
    //         className="actionBtn icon view"
    //         onClick={(e) =>
    //           setBookingDetails((prevs) => ({
    //             ...prevs,
    //             bookingDetailModal: true,
    //             bookingDetail: row?.booked_dates_v2,
    //           }))
    //         }
    //         style={{
    //           border:
    //             row?.booked_dates_v2?.length > 0
    //               ? "1px solid #bc0909"
    //               : "1px solid #9C9C9C",
    //           color: row?.booked_dates_v2?.length > 0 ? "#bc0909" : "#9C9C9C",
    //           borderRadius: "12px",
    //           cursor:
    //             row?.booked_dates_v2?.length > 0 ? "pointer" : "not-allowed",
    //         }}
    //         disabled={row?.booked_dates_v2?.length === 0}
    //       >
    //         <svg
    //           xmlns="http://www.w3.org/2000/svg"
    //           width="16"
    //           height="16"
    //           fill="currentColor"
    //           className="bi bi-arrows-angle-expand"
    //           viewBox="0 0 16 16"
    //           style={{
    //             color: row?.booked_dates_v2?.length > 0 ? "#bc0909" : "#9C9C9C",
    //           }}
    //         >
    //           <path
    //             fillRule="evenodd"
    //             d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707"
    //           />
    //         </svg>
    //       </button>
    //     </div>
    //   ),
    // },
  ];

  const tbColumnsBooked = [
    {
      dataField: "date",
      text: "Date",
      formatter: (cell, row) => {
        return <span className="tb-data minWidth100">{row?.date || "-"}</span>;
      },
    },
    {
      dataField: "consumed_status",
      text: "Session Status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data bold"
            style={{
              color: row?.consumed_status ? "#379C00" : "#D90000",
            }}
          >
            {row?.consumed_status ? "Consumed" : "Not Consumed"}
            {row?.consumed_status ? <CheckCircleIcon /> : <CrossCircleIcon />}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={memDetails.memDetailModal}
        onRequestClose={onCloseModal}
        contentLabel="Details Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer paymentDetailsModalContainer">
          <ModalHeadAndClose title="Member Detail" onClose={onCloseModal} />

          <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
            <PaymentLinkTable
              tableData={memDetails.memDetail}
              tableColumns={tbColumns}
              isFirstColSticky={true}
            />
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={bookingDetails.bookingDetailModal}
        onRequestClose={(e) => onCloseModal(e, "booking")}
        contentLabel="Booking Details Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer mod-width-50p">
          <ModalHeadAndClose
            title="Member Booking Detail"
            onClose={(e) => onCloseModal(e, "booking")}
          />

          <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
            <PaymentLinkTable
              tableData={bookingDetails.bookingDetail}
              tableColumns={tbColumnsBooked}
            />
          </div>
        </div>
      </Modal>

      <div className="flex-k flex-col-mobile my-1-k gap-05-k relative-k">
        <div>
          {dateRangerOpen ? (
            <div className="flex-k gap-05-k js-start-k">
              <Button
                variant="primary"
                onClick={() => setDateRangerOpen(false)}
              >
                Close
              </Button>
              <Button
                variant="danger"
                onClick={() => {
                  setDateRangerOpen(false);
                  setRangeState(initialRangeState);
                  setStartAndEndDate({
                    ...startAndEndDate,
                    startDate: "",
                    endDate: "",
                    selectedDates: "",
                  });
                }}
              >
                Clear
              </Button>
            </div>
          ) : startAndEndDate?.selectedDates ? (
            <button
              onClick={() => {
                setDateRangerOpen(true);
              }}
              className="btn-k border small"
              style={{
                background: "#fff",
                height: "60px",
                border: "1px solid #CDCDCD",
                fontSize: "16px",
                textTransform: "uppercase",
              }}
            >
              {startAndEndDate.selectedDates}
            </button>
          ) : (
            <button
              onClick={() => {
                setDateRangerOpen(true);
              }}
              className="btn-k border small"
            >
              Select Date
            </button>
          )}
        </div>

        {dateRangerOpen && (
          <div className="date-ranger-k">
            <DateRanger
              handleDateRangeChange={handleDateRangeChange}
              rangeState={rangeState}
              onClose={() => setDateRangerOpen(false)}
              onClear={() => {
                setDateRangerOpen(false);
                setRangeState(initialRangeState);
                setStartAndEndDate({
                  ...startAndEndDate,
                  startDate: "",
                  endDate: "",
                  selectedDates: "",
                });
              }}
            />
          </div>
        )}
        <div
          className="flex-k no-react-select-style"
          style={{
            background: "#fff",
            height: "60px",
            border: "1px solid #CDCDCD",
            borderRadius: "8px",
          }}
        >
          <ReactSelect
            classNamePrefix={"input-k-select small"}
            className="w-fit-k"
            placeholder={"Week"}
            options={weekData}
            value={selectedWeek}
            onChange={(opt) => setSelectedWeek(opt)}
          />
        </div>
      </div>

      <div className="w100P shiftDetailsContainer">
        {loader() ? (
          <Loader />
        ) : (
          <div className="w100P">
            {occupencyData ? (
              <div className="flex-k small p-0 rounded-4 overflow-auto-k">
                <div>
                  <div className="time-box border-k"></div>
                  {shiftData
                    ? shiftData.map((shift, i) => (
                        <div key={i} className="time-box border-k">
                          {
                            <span className="fs-small-k">
                              {moment(`${shift.start_time}`, "HH:mm")
                                .tz("Asia/Kolkata")
                                .format("h:mm A")}{" "}
                              {" - "}
                              {moment(`${shift.end_time}`, "HH:mm")
                                .tz("Asia/Kolkata")
                                .format("h:mm A")}
                            </span>
                          }
                        </div>
                      ))
                    : null}
                </div>

                <div className="occupency-grid">
                  {selectedWeek &&
                    selectedWeek?.value &&
                    selectedWeek?.value.map((date, i) => {
                      return (
                        <div key={i} className="time-box border-k">
                          <span>
                            {selectedWeek?.value[i - 1] !== date ? (
                              moment(date, "DD-MM-YYYY")
                                .tz("Asia/Kolkata")
                                .format("DD MMM")
                            ) : (
                              <span className="light-text">N/A</span>
                            )}
                          </span>
                        </div>
                      );
                    })}

                  {occupencyData &&
                    occupencyData.map((data, i) => {
                      return (
                        <div
                          key={`${data.date}[${i}]`}
                          className="time-box border-k"
                        >
                          {data?.name?.includes("PT Session") ? (
                            <span
                              className="light-red my-14 mx-10 pad-5"
                              style={{
                                color: data?.name?.includes("-")
                                  ? "#3D3B40"
                                  : data?.name?.includes("Expired")
                                  ? "#B80909"
                                  : "#171717",
                                background: data?.name?.includes("-")
                                  ? "#E5E1DA"
                                  : data?.name?.includes("Expired")
                                  ? "#F6EFEF"
                                  : "#A4EDE9",
                              }}
                              onClick={() =>
                                setMemDetails((prevs) => ({
                                  ...prevs,
                                  memDetailModal: true,
                                  memDetail: data?.members,
                                  currentDate: data?.current_date,
                                }))
                              }
                            >
                              {data?.name}
                            </span>
                          ) : !data?.name ? (
                            <span className="light-text">N/A</span>
                          ) : (
                            <span
                              className="badge-k medium green"
                              style={{
                                color: data?.name?.includes("-")
                                  ? "#3D3B40"
                                  : data?.name?.includes("Expired")
                                  ? "#B80909"
                                  : "#328300",
                                background: data?.name?.includes("-")
                                  ? "#E5E1DA"
                                  : data?.name?.includes("Expired")
                                  ? "#F6EFEF"
                                  : "#E2EFD5",
                              }}
                            >
                              {data?.name}
                            </span>
                          )}
                        </div>
                      );
                    })}
                </div>
              </div>
            ) : (
              <div className="flex-k js-center-k items-center-k w-full-k">
                <span>No Data Found!</span>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default OccupencyDetails;
